import Big from 'big.js'
import convertCommaNumber from 'comma-number'

const displayCommaNumber = (
  number: string | number | undefined,
  fixed?: number,
  noRounding?: boolean
) => {
  // Checking if number is numeric
  if (typeof number !== 'undefined' && isNumeric(number)) {
    const roundedNumber = !noRounding
      ? Big(number)
          .round(fixed || 2, Big.roundHalfEven)
          .toString()
      : number

    const fixedNumber =
      fixed && fixed > 0
        ? Big(roundedNumber).toFixed(fixed).toString()
        : roundedNumber

    // Return number in string with commas added
    return convertCommaNumber(fixedNumber)
  }
  // Non numeric value will return itself
  return number
}

export default displayCommaNumber
